import React from "react";
import { Link } from "gatsby";

const ThreeBlogs = ({ data }) => {
  const { chooseBlogs } = data;
  return (
    <div className="flex flex-wrap">
      <h2 className="mb-8 w-full basis-full px-4 text-center font-openSans text-4xl text-secondary">
        Understand Your Diabetes
      </h2>
      {chooseBlogs?.map((blog, index) => {
        return (
          <div
            className="mb-8 w-full basis-full px-4 lg:w-1/3 lg:basis-1/3"
            key={index}
          >
            <div className="h-full-minus bg-primary">
              <div className="h-full p-8">
                <h3 className="mb-4 font-openSans text-2xl text-white">
                  {blog.title}
                </h3>
                <div
                  className="mb-6 font-openSans text-base text-white"
                  dangerouslySetInnerHTML={{ __html: blog.excerpt }}
                ></div>
                <Link to={blog.uri} className="flex items-center">
                  <span className="text-white">Read More </span>
                  <svg
                    width="30"
                    height="31"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.7998 15.8179H25.3331"
                      stroke="white"
                      strokeWidth="0.933333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.9326 7.418L25.3326 15.818L16.9326 24.218"
                      stroke="white"
                      strokeWidth="0.933333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ThreeBlogs;
